﻿class DamDocumentItem {
	constructor(damDocuments) {
		this.damDocuments = damDocuments;
	}

	generateLiMarkup() {
		const $itemLi = document.createElement("li");
		this.appendFileName($itemLi);

		const textNode = document.createTextNode(` - ${this.damDocuments.description}`);
		$itemLi.appendChild(textNode);

		return $itemLi;
	}

	appendFileName($parentElement) {
		const $documentLink = this.createLink(this.damDocuments.hiResURLRaw, this.damDocuments.filename);

		$parentElement.appendChild($documentLink);
	}

	createLink(url, text) {
		const $documentLink = document.createElement("a");

		$documentLink.title = text;
		$documentLink.href = url;
		$documentLink.download = url;
		$documentLink.rel = "noopener";
		$documentLink.target = "_blank";
		$documentLink.innerText = text.split(".")[0];

		return $documentLink;
	}
}

export { DamDocumentItem };
